var map = {
	"./\biron_LOGO.png": 9512,
	"./1750227058273.png": 2905,
	"./1750227408961.png": 5326,
	"./1750227596037.png": 4546,
	"./ADSOL_LOGO.png": 8967,
	"./AmericanOak .png": 5495,
	"./AmericanWineries_LOGO.png": 5922,
	"./AssetMap1.png": 1045,
	"./AssetMap2.png": 3214,
	"./AssetMap_ADSOL.png": 1928,
	"./AssetMap_OTOKI.png": 9855,
	"./AssetMap_PNK.png": 3634,
	"./AssetMap_POST.png": 5725,
	"./AssetMap_SDAA.png": 6440,
	"./AssetMap_SDAA111.png": 9073,
	"./AssetMap_SDAA_07.png": 5698,
	"./AssetMap_SDAA_08.png": 3877,
	"./AssetMap_SDAA_8.png": 9313,
	"./AssetMap_SDAA_81.png": 6460,
	"./AssetMap_SKKU.png": 3953,
	"./AssetMap_SNU.png": 3107,
	"./AssetMap_Wintest.png": 5657,
	"./AssetMap_skai.png": 1039,
	"./Classic Single Malt.png": 3699,
	"./Concertmaster Sherry.png": 9239,
	"./Concertmaster Single Malt.png": 1612,
	"./Demo_LOGO.png": 2011,
	"./DistillerySelectNo_2.png": 9951,
	"./KAVALAN.png": 3274,
	"./KAVALAN_LOGO.png": 594,
	"./KAVALAN_back.png": 5830,
	"./OTOKI_LOGO.png": 7710,
	"./PKG_LOGO.png": 5592,
	"./PNK_LOGO.png": 8993,
	"./POST_LOGO.png": 4818,
	"./Port Cask.png": 5803,
	"./SDAA.png": 167,
	"./SDAA_LOGO.png": 49,
	"./SKKU_LOGO.png": 5930,
	"./SOLUM_LOGO.png": 1390,
	"./Sherry Cask.png": 8077,
	"./Single Malt.png": 6060,
	"./Skaichips_LOGO.png": 4621,
	"./Test_LOGO.png": 7548,
	"./Trace Tag Tracker management system.png": 2217,
	"./Vinho Barrique.png": 9567,
	"./Wintest_LOGO.png": 9704,
	"./audio_video.png": 6212,
	"./charger.png": 3860,
	"./computer.png": 6804,
	"./cover.png": 6943,
	"./cover1.png": 1526,
	"./cover2.png": 2765,
	"./dea_LOGO.png": 9536,
	"./default-device.png": 7402,
	"./devices.png": 1823,
	"./dvt.png": 3756,
	"./feeding-pump.png": 5523,
	"./floorplan.png": 3681,
	"./hpo.png": 5013,
	"./infusion-pump.png": 2686,
	"./inventory.png": 5842,
	"./ipad.png": 8884,
	"./iron.png": 9326,
	"./kavalanbottles.png": 7575,
	"./keyboard.png": 675,
	"./laptop.png": 2456,
	"./logistics-background.png": 478,
	"./logo.png": 3153,
	"./logo1.png": 3660,
	"./monitor.png": 9268,
	"./mouse.png": 8339,
	"./nebulizer.png": 3070,
	"./orders.png": 7323,
	"./patient-monitor.png": 5560,
	"./print.png": 4951,
	"./pulse-oxi.png": 1760,
	"./redWine.png": 8816,
	"./roseWine.png": 5330,
	"./scd.png": 5680,
	"./tag_wine.png": 6264,
	"./varios.png": 5482,
	"./warehose 2.png": 6298,
	"./warehose 3.png": 1507,
	"./whiteWine.png": 2642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;